/**
 * Single source of truth for the PUBLIC marketing/legal paths on which the Sonarly
 * session-replay tracker is allowed to record.
 *
 * The tracker records the DOM, so it must NEVER run on authenticated/credential-bearing
 * routes (/login, /signup, /[orgSlug], /admin, /onboarding, /auth, password reset) which
 * render raw one-time API keys and customer session content / PII.
 *
 * This regex SOURCE string is consumed in two places that must stay in lockstep:
 *   1. the pre-hydration inline script in `app/layout.tsx` (gates tracker init at first paint), and
 *   2. `components/sonarly-guard.tsx` (hard-stops the tracker on client-side navigation off
 *      the public set — App Router navigations never reload the document, so the init gate
 *      alone would let recording carry into the authenticated app).
 *
 * Matches: `/`, `/casestudies…`, `/privacy…`, `/terms…`, `/nf…`.
 */
export const PUBLIC_PATH_REGEX_SOURCE = '^\\/(?:$|casestudies|privacy|terms|nf)(?:\\/|$)';
